export default "__VITE_ASSET__Bo36kqbM__"